import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import ReactSelect from 'react-select';
import makeAnimated from 'react-select/animated';
import { Controller } from 'react-hook-form';
import { useCompany } from '../../../providers/Company/CompanyProvider';
import { customStyles } from '../../../models/SelectCustomStyles';
import './SelectCompany.scss';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import { useAuth } from '../../../providers/AuthProvider';

interface SelectCompanyProps {
  inputName: string;
  errors: any;
  control: any | null;
  setValue: any;
  register?: any | null;
  valueSelected: any;
  setValueSelected: Dispatch<SetStateAction<any>>;
  title?: string;
  min?: number;
  max?: number;
  onChangeSelect: (id: number) => void,
}

const SelectCompany: FC<SelectCompanyProps> = ({
  inputName,
  errors,
  control,
  setValue,
  register = null,
  valueSelected,
  setValueSelected,
  title = '',
  min = 0,
  max = 255,
  onChangeSelect
}) => {
  

  const { companysOptions, selectedCompany, setSelectedCompany } = useCompany();
  const { onInvalid } = useAuth();
  const animatedComponents = makeAnimated();

  useEffect(() => {
    if (selectedCompany && !control) {
      onChangeSelect(selectedCompany?.value);
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (valueSelected && control) {
      setValue(inputName, valueSelected);
    }
  }, [valueSelected]);

  return (
    <div className="SelectCompany" data-testid="SelectCompany">
      {control ? (
        <>
          <label className='form-control-label'>{title} *</label>
          <Controller
            control={control}
            {...register(inputName, { required: true })}
            render={({ field: { onChange, name, ref } }) => (
              <ReactSelect
                ref={ref}
                name={name}
                isClearable
                isSearchable
                options={companysOptions}
                placeholder="Selecione..."
                className={`form-control p-0 ${onInvalid(errors?.[inputName])}`}
                value={valueSelected || ''}
                defaultValue={valueSelected}
                components={animatedComponents}
                noOptionsMessage={() => 'Não há registros'}
                onChange={val => {
                  onChange(val || null);
                  setValueSelected(val);
                }}
                styles={customStyles}
              />
            )}
          />
          <ErrorMessage name={title} type={errors?.[inputName]?.type} min={min} max={max} />
        </>
      ) : (
        <ReactSelect
          name={inputName}
          isClearable={false}
          isSearchable
          options={companysOptions}
          placeholder="Selecione..."
          className={`form-control p-0`}
          value={selectedCompany || ''}
          defaultValue={selectedCompany}
          components={animatedComponents}
          noOptionsMessage={() => 'Não há registros'}
          onChange={val => {
            setSelectedCompany(val);
          }}
          styles={customStyles}
        />
      )}
    </div>
  );
}

export default SelectCompany;
